import React, { useEffect, useState } from 'react';
import CommonLayout from '../layout/CommonLayout';
import UseHeader from '../components/UserHeader';
import ReviewModal from '../components/modal/ReviewModal';
import { ButtonBase, Card } from '@mui/material';
import { Close, Label } from '@mui/icons-material';
import { FaCross, FaTimes } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { Toast, ToastContainer } from 'react-bootstrap';
import { formatDateToCustom } from '../utils/utils';


function OrderConfirm() {
    const [orderData, setOrderData] = useState(null);
    const [productsData, setProductsData] = useState([]);
    const [predefinedComments, setPredfineComments] = useState([]); // For return reasons
    const [predefinedCancelComments, setPredfineCancelComments] = useState([]); // For cancel reasons
    const [showReturnPopup, setShowReturnPopup] = useState(false);
    const [showCancelPopup, setShowCancelPopup] = useState(false);
    const [popupStage, setPopupStage] = useState('select');
    const [returnComment, setReturnComment] = useState('');
    const [cancelComment, setCancelComment] = useState('');
    const [popupMessage, setPopupMessage] = useState('');
    const [customFeedback, setCustomFeedback] = useState('');
    const [uploadedImages, setUploadedImages] = useState([]);
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
    const [selectedProductIdForReview, setSelectedProductIdForReview] = useState(null);
    const [showReturnableToaster, setShowReturnableToaster] = useState(false);

    const token = localStorage.getItem('token');
    const customerID = localStorage.getItem('customerId');
    const orderId = orderData?._id;
    useEffect(() => {
        const fetchOrderDetails = async () => {
            const pid = localStorage.getItem('pId');
            if (!token || !pid) return;

            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}customer/ordersDetails`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        token: token,
                    },
                    body: JSON.stringify({ orderId: pid }),
                });

                const result = await response.json();
                const order = result?.order;
                setOrderData({
                    _id: order?._id,
                    sellerId: order?.sellerId,
                    orderNumber: order?.orderNumber,
                    orderStatus: order?.orderStatus,
                    orderDate: order?.orderDate,
                    address: order?.address,
                    payment_type: order?.payment_type,
                    sellerName: order?.sellerName,
                    totalAmt: order?.totalAmt,
                    isReturnable: order?.products?.every(p => p.isReturnable === true),
                    cancellation_reason: order?.cancellation_reason,
                    DeliveredAt: order?.deliveredAt,
                });

                const products = order?.products?.map(product => ({
                    productId: product.productId,
                    productName: product.productName,
                    productImage: product.productImage || "https://via.placeholder.com/84x93",
                    variantTitles: product.variantId
                        ?.map(v => v.title.split(' || ')[0])
                        .join(' / '),
                    quantity: product.quantity,
                    price: product.price,
                    mrp: product.mrp,
                    isReturnable: product.isReturnable,
                })) || [];

                setProductsData(products);

                if (order?.sellerId) {
                    const sellerResp = await fetch(`${process.env.REACT_APP_BACKEND_URL}user/get-user-web/${order.sellerId}`);
                    const sellerResult = await sellerResp.json();
                    if (sellerResult.success && sellerResult.User) {
                        setOrderData(prev => ({
                            ...prev,
                            isReturnAllowed: sellerResult.User.isReturnAllowed,
                        }));
                    }
                }
            } catch (error) {
                console.error('Error fetching order details:', error);
            }
        };

        fetchOrderDetails();
    }, []);

    useEffect(() => {
        if (orderData) {
            const fetchReasons = async () => {
                try {
                    const sellerId = orderData?.sellerId;
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}customer/get-sellers-reasons-buyer/${sellerId}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            token: token,
                        },
                    });

                    const result = await response.json();

                    if (result.success && result.reasons) {
                        setPredfineComments(result.reasons.returns || []);
                        setPredfineCancelComments(result.reasons.cancellations || []);
                    } else {
                        setPredfineComments([]);
                        setPredfineCancelComments([]);
                    }
                } catch (error) {
                    console.error('Error fetching seller reasons:', error);
                    setPredfineComments([]);
                    setPredfineCancelComments([]);
                }
            };

            fetchReasons();
        }
    }, [orderData]);

    const handleSendReturnRequest = async () => {
        if (!token || !orderId || !returnComment) {
            setPopupMessage('Missing orderId, token, or comment.');
            setPopupStage('result');
            return;
        }

        try {
            let uploadedImageUrls = [];

            if (uploadedImages.length > 0) {
                const formData = new FormData();
                uploadedImages.forEach(file => {
                    formData.append("files", file);
                });

                const s3UploadResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}upload/${orderData?.sellerName}/${customerID}`, {
                    method: 'POST',
                    headers: {
                        token: token,
                    },
                    body: formData,
                });

                const s3Result = await s3UploadResponse.json();

                if (!s3Result.success || !s3Result.files || s3Result.files.length === 0) {
                    setPopupMessage('Image upload failed.');
                    setPopupStage('result');
                    return;
                }

                uploadedImageUrls = s3Result.files.map(file => file.fileUrl);
            }
            const returnRequestBody = {
                orderId,
                comment: returnComment,
                returnDate: new Date(),
                feedback: customFeedback,
                IMG: uploadedImageUrls,
            };

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}customer/request-return`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    token: token,
                },
                body: JSON.stringify(returnRequestBody),
            });

            const result = await response.json();
            if (result.success) {
                setPopupMessage('Return request submitted successfully!');
                setPopupStage('result');
                setTimeout(() => {
                    window.location.reload();
                }, 1200);
            } else {
                setPopupMessage('Return request failed: ' + (result.message || 'Unknown error.'));
                setPopupStage('result');
            }
        } catch (error) {
            setPopupMessage('Error requesting return: ' + (error.message || 'Unknown error.'));
            setPopupStage('result');
        }

    };

    const handleCancelRequest = async () => {
        if (!token || !orderId || !cancelComment) {
            setPopupMessage('Missing orderId, token, or comment.');
            setPopupStage('result');
            return;
        }


        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}customer/cancel-order-buyer/${orderId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    token: token,
                },
                body: JSON.stringify({
                    comment: cancelComment,
                    cancelDate: new Date(),
                }),
            });

            const result = await response.json();
            if (result.success) {
                setPopupMessage('Cancelled successfully!');
                setPopupStage('result');
                setTimeout(() => {
                    window.location.reload();
                }, 1200);
            } else {
                setPopupMessage('Cancel request failed: ' + (result.message || 'Unknown error.'));
                setPopupStage('result');
            }
        } catch (error) {
            setPopupMessage('Error requesting cancellation: ' + error.message);
            setPopupStage('result');
        }

    };

    const getProductImage = (item) => {
        if (item.productImage) {
            if (item.productImage.includes("https://hello-image-bucket.s3")) {
                return item.productImage
            }
            else {
                const defaultImageUrl = process.env.REACT_APP_S3_URL || "default_url_if_missing";

                const imageUrl = defaultImageUrl + item.productImage;
                return imageUrl
            }
        }
        return "https://via.placeholder.com/84x93"
    };

    const address = orderData?.address?.addressLine1 + (orderData?.address?.addressLine2 ? `, ${orderData?.address?.addressLine2}` : "");
    const handleOpenReviewModal = (productId) => {
        setSelectedProductIdForReview(productId);
        setIsReviewModalOpen(true);
    };

    const handleCloseReviewModal = () => {
        setIsReviewModalOpen(false);
        setSelectedProductIdForReview(null);
    };

    const handleReviewSubmitSuccess = () => {
        handleCloseReviewModal();
    };


    return (
        <>
            <CommonLayout>

                <UseHeader />
                <div className='order-cnf mb-3'>
                    <p>Order Number : <span className='font-weight-bold'>{orderData?.orderNumber}</span></p>
                    <p>Order Status : <span className={orderData?.orderStatus === 'NEW'
                        ? 'text-success'
                        : orderData?.orderStatus === 'PENDING'
                            ? 'text-warning'
                            : orderData?.orderStatus === 'FAILED'
                                ? 'text-danger'
                                : ''}>
                        {orderData?.orderStatus?.replaceAll('_', " ")}
                    </span></p>

                    {orderData && orderData.cancellation_reason ? <p>Cancellation Reason : <span>{orderData?.cancellation_reason}</span></p> : null}
                    <p>Order Date : <span>{formatDateToCustom(orderData?.orderDate)}</span></p>
                    <p>Customer Name : <span>{orderData?.address?.name}</span></p>
                    <p>Customer Address : <span>{address}, {orderData?.address?.district}, {orderData?.address?.state}, {orderData?.address?.zip}</span></p>
                    <p>Customer Email : <span>{orderData?.address?.email}</span></p>
                    <p>Customer Mobile : <span>{orderData?.address?.mobile}</span></p>
                    <p>Seller Name : <span>{orderData?.sellerName}</span></p>
                    {orderData?.DeliveredAt && 
                        <p>Delivery Date : <span>{formatDateToCustom(orderData?.DeliveredAt)}</span></p>
                    }
                </div>

                <div className={"order-cnf fontclass"}>
                    {productsData.map((item, index) => (
                        <React.Fragment key={index}>
                            <div className="d-flex">
                                <div className="col-3 orderConfirmImage">
                                    <img
                                        className='rounded'
                                        width={84}
                                        height={93}
                                        src={getProductImage(item)}
                                        alt={item.productName}
                                    // onError={(e) => {
                                    //     e.target.src = "https://via.placeholder.com/84x93";
                                    // }}
                                    />
                                </div>
                                <div className="col-9">
                                    <div className="col-12 px-2">
                                        <div style={{ display: "inline-block" }}>
                                            <p style={{ marginBottom: "0px", fontSize: "16px", fontWeight: "600" }}>
                                                {item.productName}
                                            </p>
                                            {item.variantTitles ? <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                                                (Variants: {item.variantTitles || "Not available"})
                                            </p> : null}
                                            {/*                                             
                                               <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                                                MRP: Rs. {item.mrp?.toLocaleString("en-IN")}
                                            </p>
                                            <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                                                Rs. {item.price ? item?.price?.toLocaleString("en-IN") : item?.mrp?.toLocaleString("en-IN")}
                                            </p> */}

                                            <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                                                MRP:{" "}
                                                <span style={{ textDecoration: item.price && item.price < item.mrp ? "line-through" : "none" }}>
                                                    ₹ {item.mrp?.toLocaleString("en-IN")}
                                                </span>
                                            </p>
                                            {(item?.mrp !== item?.price) && (
                                            <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                                                ₹ {item.price ? item.price.toLocaleString("en-IN") : item.mrp.toLocaleString("en-IN")}
                                            </p>)}

                                            <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                                                Qty: {item.quantity}
                                            </p>
                                        </div>           
                                                {/*
                                        // in future we can uncomment this condition to only show button for delivered orders only
                                        // orderData?.orderStatus === 'DELIVERED' && (
                                        */}
                                        {orderData?.orderStatus === 'DELIVERED' && (
                                                <div className="col-12 mt-2">
                                                    <button
                                                        className="btn btn-sm theme-btn"
                                                        onClick={() => handleOpenReviewModal(item.productId)}
                                                        disabled={!item.productId}
                                                    >
                                                        Rate Product
                                                    </button>
                                                </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </React.Fragment>
                            ))}
                                <div className="order-summary">
                                    <p className='pb-2'>Payment Type : <span>{orderData?.payment_type === 'COD' ? 'COD' : 'PREPAID'}</span></p>
                                    <p>Order Total : ₹ {(orderData?.totalAmt?.toLocaleString("en-IN"))}</p>
                                </div>


                                {orderData?.orderStatus === 'DELIVERED' &&
                                    orderData?.isReturnAllowed === true && (
                                        <button
                                            onClick={() => {
                                                const hasNonReturnable = productsData.some(p => p.isReturnable === false);
                                                if (hasNonReturnable) {
                                                    setShowReturnableToaster(true);
                                                } else {
                                                    setShowReturnPopup(true);
                                                    setPopupStage('select');
                                                }
                                            }}
                                            className="btn theme-btn mt-3"
                                        >
                                            Request Return
                                        </button>
                                    )}
                                {['NEW', 'SHIPPED', 'ACCEPTED'].includes(orderData?.orderStatus) && (
                                    <button onClick={() => setShowCancelPopup(true)} className="btn theme-btn-2 mt-3">
                                        Cancel Order
                                    </button>
                                )}
                            </div>

                            {showReturnPopup && (
                                // <div style={styles.popupOverlay}>
                                //     <div style={styles.popupBox}>
                                <div className="common-modal-popup">
                                    {popupStage === 'select' ? (
                                        <div className='cardBox'>
                                            <div className="cardHeader">
                                                <h3 className="h3 card-heading">Request for a Return Order</h3>
                                                <div onClick={() => setShowReturnPopup(false)} className="closeBoxWdIcon"><div className="iconBox"> <FaTimes /> </div></div>
                                            </div>
                                            <div className="cardBody">
                                                <div className="grp">
                                                    <label>Select Return Reason</label>
                                                    <select className="form-control" value={returnComment} onChange={(e) => setReturnComment(e.target.value)} style={{ padding: '8px 10px', marginBottom: 12 }}>
                                                        <option value="">-- Choose a reason --</option>
                                                        {predefinedComments.map((c, idx) => (
                                                            <option key={idx} value={c}>{c}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="grp">
                                                    <label>Additional Feedback (optional)</label>
                                                    <textarea className="form-control"
                                                        value={customFeedback}
                                                        onChange={(e) => setCustomFeedback(e.target.value)}
                                                        placeholder="Write your feedback here..."
                                                        rows={4}
                                                        style={{ width: '100%', padding: '8px 10px', marginBottom: 12 }}
                                                    />
                                                </div>
                                                <div className="grp">
                                                    <label>Upload Image (optional)</label>
                                                    <input className="form-control"
                                                        type="file"
                                                        accept="image/*"
                                                        multiple
                                                        onChange={(e) => {
                                                            const files = Array.from(e.target.files);
                                                            // console.log("Selected image files:", files);
                                                            setUploadedImages(files);
                                                        }}
                                                        style={{ marginBottom: 12 }}
                                                    />
                                                </div>
                                                <div className="grp btnBox">
                                                    <button className="btn mr-3 theme-btn"
                                                        disabled={!returnComment}
                                                        onClick={handleSendReturnRequest}>
                                                        Confirm
                                                    </button>
                                                    <button className="btn theme-btn-2" onClick={() => setShowReturnPopup(false)}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    ) : (
                                        <>
                                            <p>{popupMessage}</p>
                                            <button onClick={() => setShowReturnPopup(false)} style={styles.closeButton}>
                                                Close
                                            </button>
                                        </>
                                    )}
                                </div>
                            )}

                            {showCancelPopup && (
                                <div className="common-modal-popup">
                                    {popupStage === 'select' ? (
                                        <div className='cardBox'>
                                            <div className="cardHeader">
                                                <h3 className="h3 card-heading">Request for a Cancellation</h3>
                                                <div onClick={() => setShowCancelPopup(false)} className="closeBoxWdIcon"><div className="iconBox"> <FaTimes /> </div></div>
                                            </div>
                                            <div className="cardBody">
                                                <div className="grp">
                                                    <label>Select Cancellation Reason</label>
                                                    <select value={cancelComment} onChange={(e) => setCancelComment(e.target.value)} style={{ padding: '8px 10px', marginBottom: 12 }}>
                                                        <option value="">-- Choose a reason --</option>
                                                        {predefinedCancelComments.map((c, idx) => (
                                                            <option key={idx} value={c}>{c}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="grp btnBox">
                                                    <button className="btn mr-3 theme-btn"
                                                        disabled={!cancelComment}
                                                        onClick={handleCancelRequest}>
                                                        Confirm
                                                    </button>
                                                    <button className="btn theme-btn-2" onClick={() => setShowCancelPopup(false)}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <p>{popupMessage}</p>
                                            <button onClick={() => setShowCancelPopup(false)} style={styles.closeButton}>
                                                Close
                                            </button>
                                        </>
                                    )}

                                </div>
                            )}

                            <ToastContainer position="top-end" className="p-3">
                                <Toast
                                    onClose={() => setShowReturnableToaster(false)}
                                    show={showReturnableToaster}
                                    delay={5000}
                                    autohide
                                    bg="warning"
                                >
                                    <Toast.Header>
                                        <strong className="me-auto">Notice</strong>
                                    </Toast.Header>
                                    <Toast.Body>
                                        Some of your products are not returnable, so the order is non-returnable.
                                    </Toast.Body>
                                </Toast>
                            </ToastContainer>

                        </CommonLayout>
            { selectedProductIdForReview && (
                            <ReviewModal
                                isOpen={isReviewModalOpen}
                                onClose={handleCloseReviewModal}
                                productId={selectedProductIdForReview}
                                onSubmitSuccess={handleReviewSubmitSuccess}
                            />
                        )}
                </>
                );
}

                // Popup styles
                const styles = {
                    popupOverlay: {
                    position: 'fixed',
                top: 0,
                left: 0,
                height: '100vh',
                width: '100vw',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
    },
                popupBox: {
                    backgroundColor: 'white',
                padding: '20px 30px',
                borderRadius: 10,
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                minWidth: 300,
    },
                actionButton: {
                    marginRight: 10,
                padding: '8px 16px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: 5,
                cursor: 'pointer',
    },
                cancelButton: {
                    padding: '8px 16px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: 5,
                cursor: 'pointer',
    },
                closeButton: {
                    padding: '8px 16px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: 5,
                cursor: 'pointer',
    },
};

                export default OrderConfirm;
